import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Panel } from './pages/panel/panel';
import { Pos } from '@modules/pos/pos';
import { Empleado } from '@modules/empleado/empleado';
import { Categoria } from '@modules/categoria/categoria';
import { Cliente } from '@modules/cliente/cliente';
import { Producto } from '@modules/producto/producto';
import { TipoPago } from '@modules/tipo-pago/tipo-pago';
import { Credito } from '@modules/credito/credito';
import { VerCreditos } from '@modules/credito/ver-creditos/ver-creditos';
import { DetalleCredito } from '@modules/credito/detalle-credito/detalle-credito';
import { authGuard } from '@shared/guards/auth-guard';
import { AgregarProductoInventario } from '@shared/components/agregar-producto-inventario/agregar-producto-inventario';
import { ReporteCaja } from '@modules/reportes/reporte-caja/reporte-caja';
import { ReporteMovimientoCaja } from '@modules/reportes/reporte-movimiento-caja/reporte-movimiento-caja';
import { ReporteVenta } from '@modules/reportes/reporte-venta/reporte-venta';
import { ReporteKardex } from '@modules/reportes/reporte-kardex/reporte-kardex';
import { ConfigEmpresa } from '@shared/components/config-empresa/config-empresa';
import { ConfigSucursal } from '@shared/components/config-sucursal/config-sucursal';
import { Comandas } from '@modules/comandas/comandas';
import { ConfigPuntoImpresion } from '@shared/components/config-punto-impresion/config-punto-impresion';
import { GestionTiempo } from '@modules/gestion-tiempo/gestion-tiempo';
import { Dashboard } from '@modules/dashboard/dashboard';
import { Campana } from '@modules/campana/campana';
import { Receta } from '@modules/receta/receta';
import { MicaChat } from '@modules/mica-chat/mica-chat';
import { Auth } from './pages/auth/auth';
import { AuthRecuperarCuenta } from './pages/auth/recuperar-cuenta/recuperar-cuenta';
import { AuthLogin } from './pages/auth/login/login';
import { AuthResetPassword } from './pages/auth/reset-password/reset-password';
import { PromocionImpresora } from '@modules/promocion-impresora/promocion-impresora';
import { Reservas } from '@modules/reservas/reservas';
import { MisSesiones } from '@modules/mis-sesiones/mis-sesiones';
import { AdminSesiones } from '@modules/admin-sesiones/admin-sesiones';
import { sistemaGuard } from '@shared/guards/sistema-guard';
import { ETipoSistemasEmpresa } from '@core/enums/tipoSistemasEmpresa.enum';
import { Facturacion } from '@modules/facturacion/facturacion';
import { PideloAdmin } from '@modules/pidelo/pidelo-admin/pidelo-admin';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: Auth,
    children: [
      {
        path: 'login',
        component: AuthLogin,
      },
      {
        path: 'recuperar-cuenta',
        component: AuthRecuperarCuenta,
      },
      {
        path: 'reset-password',
        component: AuthResetPassword,
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: 'home',
    component: Home,
  },
  {
    path: 'panel',
    component: Panel,
    canActivate: [authGuard],
    children: [
      {
        path: 'config',
        children: [
          {
            path: 'empresa',
            component: ConfigEmpresa,
          },
          {
            path: 'sucursal',
            component: ConfigSucursal,
          },
          {
            path: 'punto-impresion',
            component: ConfigPuntoImpresion,
          },
          {
            path: 'promociones-impresora',
            component: PromocionImpresora,
          },
          {
            path: 'pidelo',
            component: PideloAdmin,
            canMatch: [sistemaGuard([ETipoSistemasEmpresa.PIDELO])],
          },
          {
            path: 'seguridad',
            children: [
              {
                path: 'sesiones',
                component: MisSesiones,
              },
            ],
          },
        ],
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: Dashboard,
      },
      {
        path: 'pos',
        component: Pos,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.POS])],
      },
      {
        path: 'comandas',
        component: Comandas,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.COMANDAS])],
      },
      {
        path: 'gestion-tiempo',
        component: GestionTiempo,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.CONTROLADOR_TIEMPO])],
      },
      {
        path: 'mica-chat',
        component: MicaChat,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.MICA_CHAT])],
      },
      {
        path: 'facturacion',
        component: Facturacion,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.FACTURACION])],
      },
      {
        path: 'reservas',
        component: Reservas,
        canMatch: [sistemaGuard([ETipoSistemasEmpresa.RESERVAS])],
      },
      {
        path: 'gestion',
        children: [
          {
            path: 'empleado',
            component: Empleado,
          },
          {
            path: 'categoria',
            component: Categoria,
          },
          {
            path: 'cliente',
            component: Cliente,
          },
          {
            path: 'producto',
            component: Producto,
          },
          {
            path: 'recetas',
            component: Receta,
          },
          {
            path: 'campanas',
            component: Campana,
          },
          {
            path: 'sesiones',
            component: AdminSesiones,
          },
          {
            path: 'agregar-inventario',
            component: AgregarProductoInventario,
          },
          {
            path: 'pagos',
            component: TipoPago,
          },
          {
            path: 'creditos',
            children: [
              {
                path: '',
                component: Credito, // lista todos los créditos
              },
              {
                path: 'ver',
                children: [
                  {
                    path: 'detalle/:ventaId',
                    component: DetalleCredito, // detalle del crédito
                  },
                  {
                    path: ':clienteId',
                    component: VerCreditos, // créditos por cliente
                  },
                ],
              },
            ],
          },
          // reportes
          {
            path: 'reporte',
            children: [
              {
                path: 'caja',
                component: ReporteCaja,
              },
              {
                path: 'movimiento-caja',
                component: ReporteMovimientoCaja,
              },
              {
                path: 'venta',
                component: ReporteVenta,
              },
              {
                path: 'kardex',
                component: ReporteKardex,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
